"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minor2DP = exports.major4DP = exports.major0DP = exports.smartMajor2DP = exports.major2DP = void 0;
var config_service_1 = require("../config/config-service");
var types_1 = require("./types");
/**
 * Wrap Intl.NumberFormat to account for the lack of "narrowSymbol" support on
 * older versions of ios safari.
 *
 * https://caniuse.com/?search=currencyDisplay
 */
var wrappedNumberFormat = function (options) {
    try {
        return Intl.NumberFormat(getLocale(), __assign({ style: 'currency', 
            // @ts-ignore
            currencyDisplay: 'narrowSymbol' }, options));
    }
    catch (_a) {
        return Intl.NumberFormat(getLocale(), __assign({ style: 'currency', 
            // @ts-ignore
            currencyDisplay: 'symbol' }, options));
    }
};
var major2DP = function (amount, code) {
    if (!isValidCurrency(code)) {
        return '';
    }
    var value = convertCurrencyStringToNumber(amount);
    return wrappedNumberFormat({
        currency: code,
    }).format(value / 100);
};
exports.major2DP = major2DP;
var hasDecimalPlaces = function (majorAmount) { return majorAmount % 1 !== 0; };
var smartMajor2DP = function (amount, code) {
    var num = Number(amount);
    if (isNaN(num)) {
        return '';
    }
    return hasDecimalPlaces(num / 100)
        ? (0, exports.major2DP)(amount, code)
        : (0, exports.major0DP)(amount, code);
};
exports.smartMajor2DP = smartMajor2DP;
var major0DP = function (amount, code) {
    if (!isValidCurrency(code)) {
        return '';
    }
    var value = Math.round(convertCurrencyStringToNumber(amount, 0) / 100);
    // we only want maxFractionDigits
    // but we also need to set minimumFractionDigits due to the way
    // the spec is implemented in some browers. Chrome is ok locally
    // but int tests and other browsers will fail since they set
    // `minimumFractionDigits` to 2, and max must be higher or equal to min
    // otherwise an error is thrown and nothing will render.
    return wrappedNumberFormat({
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};
exports.major0DP = major0DP;
var major4DP = function (amount, code) {
    if (!isValidCurrency(code)) {
        return '';
    }
    var value = convertCurrencyStringToNumber(amount, 2);
    return wrappedNumberFormat({
        currency: code,
        minimumFractionDigits: 4,
    }).format(value / 100);
};
exports.major4DP = major4DP;
var minor2DP = function (amount, code) {
    if (!isValidCurrency(code)) {
        return '';
    }
    var value = Intl.NumberFormat(getLocale(), {
        minimumFractionDigits: 2,
    }).format(convertCurrencyStringToNumber(amount));
    switch (code) {
        case 'EUR':
        case 'AUD':
        case 'AUX':
            return value + 'c';
        case 'SEK':
            return value + '\xa0öre';
        case 'GBP':
        case 'GBX':
        default:
            return value + 'p';
    }
};
exports.minor2DP = minor2DP;
var isValidCurrency = function (code) {
    var isValid = types_1.CurrencyCodes.includes(code);
    if (!isValid) {
        consoleError(code);
    }
    return isValid;
};
var getLocale = function () {
    var locale = config_service_1.configService.getConfig().locale;
    return locale || 'en-GB';
};
var convertCurrencyStringToNumber = function (amount, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 2; }
    return (Math.round(parseFloat(amount + '') * Math.pow(10, decimalPlaces)) /
        Math.pow(10, decimalPlaces));
};
var consoleError = function (code) {
    var ERROR_MESSAGE = "Error: currency code ".concat(code, " not found.\n\nIt looks like the currency code entered is either incorrect or not supported yet.\nPlease check the code entered.\n");
    console.error(ERROR_MESSAGE);
};
